import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Globals } from '../../utils/globals';
/** Will portal its children into a given root element */
export const Portal = ({ portalToSelector, children, portalTo }) => {
    const [selectedRootElement, setSelectedRootElement] = React.useState();
    // the root element is not always available as a result of that query selection on the initial render, so must be assigned to a piece of state
    React.useEffect(() => {
        var _a, _b;
        if (portalToSelector) {
            const element = (_a = Globals.Document) === null || _a === void 0 ? void 0 : _a.querySelector(portalToSelector);
            setSelectedRootElement(element || undefined);
        }
        else if (portalTo) {
            setSelectedRootElement(portalTo);
        }
        else {
            setSelectedRootElement((_b = Globals.Document) === null || _b === void 0 ? void 0 : _b.body);
        }
    }, [portalTo, portalToSelector]);
    if (!selectedRootElement) {
        return null;
    }
    return ReactDOM.createPortal(children, selectedRootElement);
};
